export const formatCurrency = (
  value: number | string | null | undefined,
): string => {
  if (value == null || value === '') return '—';

  const amount = Number(
    typeof value === 'string'
      ? value.replace(/\s/g, '').replace(',', '.')
      : value
  );

  if (!Number.isFinite(amount)) {
    console.log(amount, value);
    return '—'
  }

  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};